import { render, staticRenderFns } from "./TreasurehuntPreviewObjectQuestion.vue?vue&type=template&id=3d1b151a&scoped=true&"
import script from "./TreasurehuntPreviewObjectQuestion.vue?vue&type=script&lang=js&"
export * from "./TreasurehuntPreviewObjectQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TreasurehuntPreviewObjectQuestion.vue?vue&type=style&index=0&id=3d1b151a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1b151a",
  null
  
)

export default component.exports